/**
 * Privacy-safe base name for a customer-downloaded estimate PDF.
 *
 * When the merchant hides the estimate number on customer-facing output
 * (the design hides `estimateDetails.estimateNumber`), the number must not leak into the
 * saved file name either. Extracted as a pure function so the visibility gate
 * is unit-testable independently of the large public quote route component.
 *
 * Callers append the extension/suffix, e.g. `${base}.pdf` or `${base}-signed.pdf`.
 */
export function estimatePdfBaseName(args: {
  estimateNumber: string | null | undefined;
  /** `layoutVisibility(design).estimateNumber` — whether the number may be shown to the customer. */
  showEstimateNumber: boolean;
}): string {
  const { estimateNumber, showEstimateNumber } = args;
  return showEstimateNumber && estimateNumber ? `estimate-${estimateNumber}` : 'estimate';
}
